import { cardBase, thClass, tdClass, rowClass, fmtDate, ViewAllLink } from './dashboardUtils';

export function HousekeepingWidget({ cleanings, onSelectTenant }) {
  return (
    <div className={`${cardBase} overflow-hidden`}>
      <div className="flex items-center justify-between px-6 pt-5 pb-3">
        <h2 className="text-[15px] font-semibold text-gray-900">Upcoming Housekeeping</h2>
        <ViewAllLink to="/housekeeping" label="housekeeping" />
      </div>
      {cleanings.length === 0 ? (
        <p className="px-6 pb-5 text-[13px] text-gray-400">No cleanings scheduled this week</p>
      ) : (
        <table className="w-full">
          <thead><tr className="border-b border-gray-100">
            <th className={thClass}>Unit</th><th className={thClass}>Tenant</th><th className={thClass}>Check-Out</th>
            <th className={thClass}>Check-In</th><th className={thClass}>Cleaner</th><th className={thClass}>Status</th>
          </tr></thead>
          <tbody>
            {cleanings.map(c => (
              <tr key={c.id} className={`${rowClass} cursor-pointer`} onClick={() => onSelectTenant({ id: c.tenant_id, name: c.tenant_name, unit_number: c.unit_number, property_name: c.property_name })} data-testid={`cleaning-tenant-${c.id}`}>
                <td className={`${tdClass} text-gray-500`}>{c.property_name} {c.unit_number}</td>
                <td className={`${tdClass} font-medium text-gray-900`}>{c.tenant_name}</td>
                <td className={`${tdClass} text-gray-500 tabular-nums`}>{fmtDate(c.check_out_date)}</td>
                <td className={`${tdClass} text-gray-500 tabular-nums`}>{fmtDate(c.next_check_in_date)}</td>
                <td className={`${tdClass} text-gray-500`}>{c.assigned_cleaner_name || '-'}</td>
                <td className={tdClass}>
                  <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium ${c.confirmed ? 'bg-emerald-50 text-emerald-700' : 'bg-amber-50 text-amber-700'}`}>
                    <span className={`h-1.5 w-1.5 rounded-full ${c.confirmed ? 'bg-emerald-500' : 'bg-amber-500'}`} />
                    {c.confirmed ? 'Complete' : 'Pending'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
